import { withInstall } from '@code-monkey-ui/utils'

import Slider from './src/slider.vue'

export const ElSlider = withInstall(Slider)
export default ElSlider

export * from './src/slider'
export * from './src/constants'
